.SegmentedControl {
    display: flex;
    position: relative;
    overflow: hidden;
    padding: 4px;
    border: 1px solid var(--soniq-t--global--border--color--card--default);
    border-radius: var(--soniq-t--global--border--radius--primary--md);
    color: var(--soniq-t--global--text--color--primary--default);

    /* The sliding highlight behind the selected segment.
       Width and position are set from SegmentedControl.tsx. */
    &::before {
        content: '';
        position: absolute;
        top: 4px;
        bottom: 4px;
        left: 0;
        z-index: 0;
        width: var(--highlight-width, 0);
        transform: translateX(var(--highlight-x-pos, 0));
        border-radius: var(--soniq-t--global--border--radius--primary--md);
        background: var(--soniq-t--global--background--color--selected--default);
        opacity: 0;
    }

    &[data-highlighted]::before {
        opacity: 1;
    }

    &[data-animated]::before {
        transition: transform 0.5s ease, width 0.5s ease;
    }

    &:has(.SegmentedControl__input:focus-visible) {
        outline: var(--soniq-t--global--focus-ring--width) solid var(--soniq-t--global--focus-ring--color);
        outline-offset: var(--soniq-t--global--focus-ring--offset);
    }

    &.isDisabled[data-highlighted]::before {
        opacity: 0.5;
    }
}

.SegmentedControl__segment {
    position: relative;
    z-index: 1;
    flex-grow: 1;
    min-width: 20px;
    padding: 4px;
    border-radius: var(--soniq-t--global--border--radius--primary--md);
    text-align: center;
    cursor: pointer;
    transition: color 0.5s ease, background 120ms ease;

    &:hover:not(.isActive, .isDisabled) {
        background: var(--soniq-t--global--background--color--surface--hover);
    }

    &.isActive {
        color: var(--soniq-t--global--text--color--selected--default);
    }

    &.isDisabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
}

/* The real radio input, stretched invisibly over its segment so
   clicks, arrow keys and screen readers work as a radio group. */
.SegmentedControl__input {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    opacity: 0;
    cursor: inherit;
}

@media (prefers-reduced-motion: reduce) {
    .SegmentedControl[data-animated]::before,
    .SegmentedControl__segment {
        transition: none;
    }
}
